import PropTypes from "prop-types";
import classnames from "classnames";

import closeIcon from 'apps/QuoterApp/assets/images/Close Icon.svg';

import './styles.scss';


function BaseModal({className, show, onClose, children}) {
    return show && <div className={"BaseModal"}>
        <div className={"BaseModal__Scroll"}>
            <div className={classnames("BaseModal__Body", className)}>
                <button className={"BaseModal__Body__Close"} onClick={onClose}>
                    <img src={closeIcon} alt={"Close"}/>
                </button>

                {children}
            </div>
        </div>
    </div>;
}

BaseModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node,
}

export default BaseModal;
